export let basicToolPanels = [
	'columns',
	'filters'
];
